<template>
  <v-dialog
    v-model="modalVisible"
    scrollable
    :fullscreen="$vuetify.breakpoint.xsOnly"
    persistent
    v-bind="$attrs"
  >
    <v-card v-bind="cardAttributes">
      <v-btn
        icon
        style="position:absolute; right: 15px; top: 10px"
        @click="modalVisible = false"
      >
        <v-icon
          color="grey darken-1"
        >
          fa fa-times
        </v-icon>
      </v-btn>
      <v-card-title
        v-if="!$slots.title"
        class="grey-bg px-6 py-3"
      >
        {{ title }}
      </v-card-title>
      <slot
        v-else
        name="title"
      />
      <slot />
      <v-divider />
      <slot name="actions" />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CardDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    cardAttributes: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    modalVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style scoped>

</style>
